<script lang="ts">
    import { createEventDispatcher } from "svelte";

    import FormCheckbox from "./FormChooseField.svelte";

    type FormCheckboxGroupOption = { label: string; value: number | string };
    export let options: FormCheckboxGroupOption[];
    let values: FormCheckboxGroupOption["value"][];
    export { values as value };
    const dispatch = createEventDispatcher();
    const onChange = (option: FormCheckboxGroupOption) => (event: Event) => {
        const newValues = values.slice();
        const isAlreadyChecked = newValues.includes(option.value);
        if (isAlreadyChecked) {
            const valueIdx = newValues.indexOf(option.value);
            if (valueIdx > -1) {
                newValues.splice(valueIdx, 1);
                return dispatch("change", { value: newValues, event });
            }
        }
        newValues.push(option.value);
        dispatch("change", { value: newValues, event });
    };
    $: isChecked = (value: FormCheckboxGroupOption["value"]) => {
        return values?.includes(value);
    };
</script>

<fieldset class="gw-form-checkbox-group gw-default-reset">
    {#each options as option (option.value)}
        <FormCheckbox
            ariaLabel={option.label}
            text={option.label}
            checked={isChecked(option.value)}
            on:change={onChange(option)}
        />
    {/each}
</fieldset>

<style>
    .gw-form-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5em;
        padding-left: 1px;
    }
</style>
